import { connect } from 'react-redux';

import OpenVendorComponent from './OpenVendorComponent';

import { onModalClose } from '../Modal/actions';

import { openAccessPointForVendor } from './utils';

import * as selectors from './selectors';

const form = 'OpenVendor';

const mapStateToProps = (state) => {
  const accessPoint = selectors.getAccessPoint(state);
  return {
    accessPoint,
    form,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data, props) => {
    const { accessPoint, onModalClose } = props;
    return openAccessPointForVendor(dispatch, accessPoint, data, onModalClose);
  },
  onModalClose: () => onModalClose(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OpenVendorComponent);
